import React from 'react';

export interface ValidatedFilesProps {
  width?: string;
  height?: string;
  color?: string;
}

const ValidatedFiles: React.FC<ValidatedFilesProps> = (props): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="81.062"
      height="73.06"
      viewBox="0 0 81.062 73.06"
    >
      <g transform="translate(-524 -568)">
        <path
          fill="#fff"
          d="M-491.316,854.208a1.2,1.2,0,0,1-.663-1.179q.035-11.868,0-23.735a8.714,8.714,0,0,0-.4-2.633c-1-3.05-3.671-4.8-7.218-4.8q-19.42,0-38.841.007h-1.137c0-1.494.064-2.888-.012-4.275a7.2,7.2,0,0,0-7.762-6.9,96.5,96.5,0,0,1-9.687-.01,7.219,7.219,0,0,0-7.4,4.979c-.17.492-.311.993-.466,1.491V866.53a.939.939,0,0,1,.07.142c1.305,4.239,3.532,5.878,7.988,5.878q20.409,0,40.818-.01c.56,0,.878.082,1.1.694a15.934,15.934,0,0,0,17.9,10.243,15.986,15.986,0,0,0,12.9-12.911A15.961,15.961,0,0,0-491.316,854.208Z"
          transform="translate(1088.904 -242.674)"
        />
        <g transform="translate(1088.904 -242.674)">
          <path
            fill="#384164"
            d="M-491.316,854.208a1.2,1.2,0,0,1-.663-1.179q.035-11.868,0-23.735a8.714,8.714,0,0,0-.4-2.633c-1-3.05-3.671-4.8-7.218-4.8q-19.42,0-38.841.007h-1.137c0-1.494.064-2.888-.012-4.275a7.2,7.2,0,0,0-7.762-6.9,96.5,96.5,0,0,1-9.687-.01,7.219,7.219,0,0,0-7.4,4.979c-.17.492-.311.993-.466,1.491V866.53a.939.939,0,0,1,.07.142c1.305,4.239,3.532,5.878,7.988,5.878q20.409,0,40.818-.01c.56,0,.878.082,1.1.694a15.934,15.934,0,0,0,17.9,10.243,15.986,15.986,0,0,0,12.9-12.911A15.961,15.961,0,0,0-491.316,854.208Zm-24.558,15.167h-.734l-40.494.006c-3.114,0-4.636-1.534-4.636-4.674q0-7.006,0-14.012c.006-5.9-.009-27.32.008-32.113.011-3.255,2.083-4.992,5.568-4.642a46.9,46.9,0,0,0,8.573-.012c2.9-.241,4.821,1.47,4.851,4.261.017,1.555,0,3.111,0,4.667,0,1.7.51,2.2,2.228,2.2h40.889c2.928,0,4.482,1.554,4.483,4.49q0,10.955,0,21.911v.921c-5.51-1.468-10.52-.611-14.885,2.952C-514.416,858.915-516.256,863.672-515.873,869.375Zm15.918,11.161a12.763,12.763,0,0,1-12.752-13.083,12.782,12.782,0,0,1,12.9-12.541,12.823,12.823,0,0,1,12.74,12.964A12.828,12.828,0,0,1-499.955,880.535Z"
          />
          <path
            fill="#2890c1"
            d="M-193.339,1137.9c-.29.228-.567.472-.848.711l-6.223,5.29c-1.359-1.221-2.648-2.351-3.9-3.518a1.69,1.69,0,0,0-2.45-.219,1.6,1.6,0,0,0,.143,2.441q2.208,2.32,4.428,4.628a1.635,1.635,0,0,0,2.617.154c1.076-.89,2.133-1.8,3.2-2.709,1.705-1.453,3.42-2.894,5.108-4.367a1.581,1.581,0,0,0,.2-2.318A1.564,1.564,0,0,0-193.339,1137.9Z"
            transform="translate(-300.95 -274.988)"
          />
        </g>
      </g>
    </svg>
  );
};
export default ValidatedFiles;
